module.exports = __webpack_public_path__ + "static/media/6.a78fa3e0.jpeg";